export default __webpack_public_path__ + "static/media/Cereals.4a6b2ab2.jpg";